import api from "../../../../utils/api";

export const OTP_TYPE = {
  EMAIL: "EMAIL",
  PHONE: "PHONE",
};

// Send OTP to email or phone (depending on type)
export const sendOtp = async (target, type) => {
  return await api.post("/buyer/otp/send", { target, type });
};

// Verify OTP for email or phone
export const verifyOtp = async (target, type, code) => {
  const res = await api.post("/buyer/otp/verify", { target, type, code });
  return res.data;
};

export const submitFullRegistration = async ({
  email,
  password,
  firstName,
  lastName,
  phone,
  agreedToTerms,
}) => {
  const res = await api.post("/buyer/auth/register", {
    name: `${firstName} ${lastName}`.trim(),
    email,
    password,
    phone: phone ? `+61${phone}` : null,
  });
  return res.data;
};

export const checkPhoneNumberExists = async (phone) => {
  // Normalize phone string to match server format
  const normalized = phone.replace(/\s+/g, "");
  const res = await api.post("/buyer/auth/check-phone", { phone: normalized });
  const { exists } = res.data || {};
  return { exists: !!exists };
};

export const verifyAndRouteEmailUser = async (email, codeInput) => {
  // 1. Verify OTP
  await verifyOtp(email, OTP_TYPE.EMAIL, codeInput);

  // 2. Check account status
  const { data } = await api.get(
    `buyer/auth/check-email-status?email=${email}`
  );

  return {
    isExistingUser: data.exists && data.hasPassword,
  };
};

export const loginWithEmail = async (email, password) => {
  const res = await api.post("/buyer/auth/login", { email, password });
  const { token, buyer } = res.data;

  // Store token and vendor for future use
  localStorage.setItem("jwtToken", token);
  localStorage.setItem("buyer", JSON.stringify(buyer));

  return { token, buyer };
};

export const sendPasswordResetEmail = async (email) => {
  const res = await api.post("/buyer/auth/forgot-password", { email });
  return res.data;
};

export const resetPassword = async (token, newPassword) => {
  const res = await api.post("/buyer/auth/reset-password", {
    token,
    newPassword,
  });
  return res.data;
};

export const getCurrentBuyer = async (token) => {
  const res = await api.get("/buyer/auth/me", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return res.data;
};

export const enableAppleLogin =
  process.env.REACT_APP_ENABLE_APPLE_LOGIN === "true";

const getAuthRedirectBase = () => {
  const envBase = process.env.REACT_APP_API_URL;
  if (envBase) return envBase.replace(/\/$/, "");
  if (process.env.NODE_ENV !== "production") return "http://localhost:3001";
  throw new Error("REACT_APP_API_URL is required for auth redirects.");
};

export const redirectToGoogleLogin = () => {
  window.location.href = `${getAuthRedirectBase()}/buyer/auth/google`;
};

export const redirectToAppleLogin = () => {
  if (!enableAppleLogin) return;
  window.location.href = `${getAuthRedirectBase()}/buyer/auth/apple`;
};
